export function scrollIntoDomElement(selector: string) {
	const domElement = document.querySelector(`#${selector}`);
	if (!domElement) return;
	domElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
}
